import { Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';
import { ActionSheetController, ModalController, ViewWillEnter } from '@ionic/angular';
import { Observable, firstValueFrom } from 'rxjs';
import { CurrencyMaskConfig } from 'ng2-currency-mask';
import { PedidoService } from 'src/app/core/services/http/pedido.service';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { ApiResponse } from '../../interfaces/api-response.interface';
import { MetodosModal } from '../../interfaces/metodos-modal.interface';
import { MesasDisponiveisModel } from '../../models/mesas-disponiveis.model';
import { MesasOcupadasModel } from '../../models/mesas-ocupadas.model';
import { VendasDetalheModel } from '../../models/vendas-detalhe.model';
import { HelpersUtil } from '../../utils/helpers.util';
import { DialogStateUtil } from '../../utils/dialog-state.util';

@Component({
    selector: 'app-transferencia-mesa',
    templateUrl: './transferencia-mesa.component.html',
    styleUrls: ['./transferencia-mesa.component.scss'],
})
export class TransferenciaMesaComponent implements ViewWillEnter, MetodosModal {
    //ModalProps
    public readonly mesa: MesasDisponiveisModel | MesasOcupadasModel;

    @ViewChild('inpTransferirPara', { static: false }) public inpTransferirPara: ElementRef<HTMLInputElement>;

    public arrDets: VendasDetalheModel[] = [];
    public numeroComandaDestino: number;

    constructor(
        private renderer: Renderer2,

        private actionSheetCtrl: ActionSheetController,
        private modalCtrl: ModalController,

        private pedidoService: PedidoService,
    ) { }

    public async cancel() {
        await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);

        DialogStateUtil.dialogIsClosed();
    }

    public async confirm() {
        if (this.numeroComandaDestino === this.mesa.numeroComanda) return;

        const statusMesaApiResponse = await firstValueFrom(this.pedidoService.verificarMesaOcupada(this.numeroComandaDestino));

        if (statusMesaApiResponse.success) {
            const statusMesa = statusMesaApiResponse.data;

            if (statusMesa) {
                const confirmou = await this.confirmarTransferencia();

                if (!confirmou) return;
            }
        }

        const itensSelecionado = this.arrDets.filter(l => l.checked);
        const codigosDet = itensSelecionado.map(l => l.codigo);

        const dataClose = new TransferenciaMesaDataClose(this.numeroComandaDestino, codigosDet);

        await this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);

        DialogStateUtil.dialogIsClosed();
    }

    public disabledConfirm() {
        return !this.numeroComandaDestino;
    }

    public ionViewWillEnter(): void {
        this.pedidoService.obterListaDets(this.mesa.numeroComanda).subscribe(res => {
            if (!res.success || res.data.length <= 0) return;

            for (let det of res.data) {
                det.checked = true;
            }
            
            this.arrDets = res.data;
        });

        HelpersUtil.executeAfterDelay(() => this.renderer.selectRootElement(this.inpTransferirPara.nativeElement).focus())
    }

    @HostListener('window:keydown', ['$event'])
    public async handleKeyboardEvent(event: KeyboardEvent): Promise<void> {
        switch (event.key) {
            case KeyboardKeysEnum.F5:
                await this.handleF5Key();
                break;
        }
    }

    private async confirmarTransferencia(): Promise<boolean> {
        const actionSheet = await this.actionSheetCtrl.create({
            header: 'Esta mesa de destino está ocupada. Continuar transferência?',
            buttons: [
                {
                    text: 'Sim',
                    role: ModalRoleEnum.CONFIRM,
                    id: 'btnSimActionSheet'
                },
                {
                    text: 'Não',
                    role: ModalRoleEnum.CANCEL,
                    id: 'btnNaoActionSheet'
                },
            ],
            backdropDismiss: false
        });

        await actionSheet.present();

        const btnSim = document.querySelector('#btnSimActionSheet') as HTMLButtonElement;

        HelpersUtil.executeAfterDelay(() => btnSim.focus(), 200);

        const { role } = await actionSheet.onWillDismiss();

        return role === ModalRoleEnum.CONFIRM;
    }

    private async handleF5Key() {
        if (!this.disabledConfirm()) {
            await this.confirm();
        }
    }
}

export class TransferenciaMesaDataClose {
    constructor(
        public numeroComandaDestino: number,
        public codigosDet: number[]
    ) { }
}
